<div nz-row *ngFor="let icon of iconType" style="display: inline-block;">
  <div nz-col nzXl="6" nzLg="6" nzMd="12" nzSm="12">
    <a (click)="iconClicked(icon)"> <i nz-icon [nzType]="icon.icon" nzTheme="outline" [ngClass]="icon.color" nz-tooltip
        nzTooltipTitle="{{icon.tooltip}}"></i></a>
  </div>
</div>
